// extracted by mini-css-extract-plugin
export var container = "_kv-0";
export var dotAnimation = "_kv-2";
export var dotsLoading = "_kv-1";